import { GraphQLClient } from "graphql-request";
import { useRuntimeConfig } from "nuxt/app";
import { getSdk } from "#gql/default";
import { usePublicDataRequest } from "./public-data-request";

export function usePublicContent() {
    const { strapiUrl, strapiToken } = useRuntimeConfig().public;
    // Public content always uses the service token, never a visitor's cookies.
    const sdk = getSdk(new GraphQLClient(`${strapiUrl}/graphql`, {
        headers: { Authorization: `Bearer ${strapiToken}` },
    }));
    const cache = usePublicDataRequest();

    return {
        getConfig: () => cache(["cms", "config"], () => sdk.GetConfig(), 300),
        getNavigation: (variables: Parameters<typeof sdk.RenderNavigation>[0]) =>
            cache(["cms", "navigation", variables], () => sdk.RenderNavigation(variables), 300),
        getHomePage: (variables: Parameters<typeof sdk.GetHomePage>[0]) =>
            cache(["cms", "home", variables], () => sdk.GetHomePage(variables), 300),
        getContactPage: (variables: Parameters<typeof sdk.GetContactPage>[0]) =>
            cache(["cms", "contact", variables], () => sdk.GetContactPage(variables), 300),
        getStaticPage: (variables: Parameters<typeof sdk.GetStaticPage>[0]) =>
            cache(["cms", "page", variables], () => sdk.GetStaticPage(variables), 300),
    };
}
